import axios from 'axios';
const api = axios.create({ baseURL: 'https://bsp.aiworldcommunity.com/api' || '/api' });
export const TOKEN_KEY = 'bsp2_token';
api.interceptors.request.use(c => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) c.headers.Authorization = `Bearer ${t}`;
  // Programme switcher: when a specific programme is selected (not "all"),
  // send it on every request so the backend scopes results to it. The user
  // can only ever pick programmes they're allowed to see, so this is a
  // display filter layered on top of the server's own access scoping.
  const activeProg = localStorage.getItem('bsp2_active_prog');
  if (activeProg && activeProg !== 'all') {
    c.params = { ...(c.params || {}), programmeId: activeProg };
  }
  return c;
});
api.interceptors.response.use(r => r, e => {
  if (e.response?.status === 401 && !window.location.pathname.startsWith('/login')) {
    localStorage.removeItem(TOKEN_KEY); window.location.href = '/login';
  }
  return Promise.reject(Object.assign(new Error(e.response?.data?.error || e.message), { status: e.response?.status }));
});
export async function downloadCsv(path, params, name) {
  const t = localStorage.getItem(TOKEN_KEY);
  const q = new URLSearchParams(params || {}).toString();
  const res = await fetch(`${api.defaults.baseURL}${path}${q ? '?' + q : ''}`, { headers: { Authorization: `Bearer ${t}` } });
  if (!res.ok) throw new Error('Export failed');
  const blob = await res.blob(); const a = document.createElement('a');
  a.href = URL.createObjectURL(blob); a.download = name || 'export.csv';
  document.body.appendChild(a); a.click(); a.remove(); URL.revokeObjectURL(a.href);
}
export default api;
